module.exports = __webpack_public_path__ + "static/bg (10)-87d1e1f0c7fe4ee2685fd123dac9a9c5.jpg";